import React from "react";
import { useState, useMemo, useEffect } from "react";

import Form from "../utils/Form";
import { about_us, about_us_update } from "../../actions/Setting/about_us";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { Card } from "@mui/material";
// import { download_gumlet_video_file, gumlet_movie_excel_sheet_detail } from "../../actions/Setting/fileUpload";
import * as Action from "../../actions/Setting/fileUpload"
import { bindActionCreators } from "redux";
import axios from "axios";
export default function FileUpload() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const {download_gumlet_video_file , gumlet_movie_excel_sheet_detail} = bindActionCreators(Action , dispatch)
  const [loading, setloading] = useState(false);
  // useEffect(()=>{
  //     dispatch(about_us())
  // },[])
  // const aboutus=useSelector((state)=>state.setting?.aboutus?.data[0])

  // useMemo(()=>{
  //     setForm({...aboutus})
  //     // console.log("aboutus",form,aboutus)
  // },[aboutus])

  const handleDownload = async ()=>{
    setloading(true)
    // const resData = await download_gumlet_video_file()
    // if(resData?.statuscode == 200){
    //   setloading(false)
    // }
          // axios({
          //     method: 'GET',
          //     url: `https://api.gurjari.app/api/download_gumlet_video_file/`, // Pass the correct endpoint here
          //     // data: api_data, // Pass the payload
          //     responseType: 'blob', // Important for binary data
          //   })
          //   .then((response) => {
          //     console.log(response.data); // Log to confirm the content
          //     const url = window.URL.createObjectURL(new Blob([response.data]));
          //     const link = document.createElement('a');
          //     link.href = url;
          //     link.setAttribute('download', "gurjari");
          //     document.body.appendChild(link);
          //     link.click();
          //     document.body.removeChild(link);
          //   })
          //   .catch((error) => {
          //     console.error("Error exporting the file:", error);
          //   })
          axios({
            method: 'GET',
            url: 'https://api.gurjari.app/api/download_gumlet_video_file/',
            responseType: 'blob', // Important for binary files
          })
          .then((response) => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'Gumlet video detail.xlsx'; // Fallback filename
           
            if (contentDisposition) {
              const match = contentDisposition.match(/filename="(.+)"/);
              if (match && match[1]) {
                fileName = match[1];
              }
            }
           
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setloading(false)
          })
          .catch((error) => {
            console.error("Error exporting the file:", error);
          });
  }

  const formStructure = [
    {
      id: "1",
      type: "file1",
      title: "Upload Csv File",
      variant: "File",
      name: "excel_file",
      size: "12",
      accept: ".csv,.xls,.xlsx",
      required: true,
    },

    // {
    // 	id: "2",
    // 	type: "inputBox",
    // 	title: "Facebook URL",
    // 	name: "facebook_url",
    // },
    // {
    // 	id: "2",
    // 	type: "inputBox",
    // 	title: "Linkedln URL",
    // 	name: "linkedln_url",
    // },
    // {
    // 	id: "2",
    // 	type: "inputBox",
    // 	title: "Youtube URL",
    // 	name: "youtube_url",
    // },
    // {
    // 	id: "2",
    // 	type: "inputBox",
    // 	title: "Instagram URL",
    // 	name: "instagram_url",
    // },

    {
      id: "8",
      type: "button",
      title: "Submit",
    },
  ];

  const handleSubmit = (event) => {
    // console.log(form,"formmmm")
    event.preventDefault();
    const data = new FormData();

    Object.keys(form).map((key) => data.append(key, form?.[key]));

    dispatch(Action.gumlet_movie_excel_sheet_detail(data));

    navigate("/Dashboard/Dashboard");
    setForm({})
  };

  return (
    <>
      <Form
        formStructure={formStructure}
        handleSubmit={handleSubmit}
        formTitle={"Gumlet Video Detail Download"}
        key={"Form"}
        setForm={setForm}
        form={form}
      />
      <Card
        sx={{
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
          borderRadius: "10px",
          p: "25px 20px 15px",
          mb: "15px",
          color: "black",

          backgroundColor: "#f8fcff",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            flexDirection: "column",
          }}
        >
          <p>Download Gumlet CSV File</p>
          <LoadingButton
            type="button"
            variant="contained"
            //   disabled={value?.disabled}
            loading={loading}
            // endIcon={<SendIcon />}
            // loading={loading}
            loadingPosition="end"
            style={{
              background:
                "linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%)",
            }}
            sx={{
              mt: 1,
              textTransform: "capitalize",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "13px",
              padding: "12px 20px",
              minWidth: "0",
              minHeight: "0",
              color: "#fff !important",
            }}
              onClick={(e) =>
                handleDownload()
              }
          >
            {loading ? (
              <span style={{ paddingRight: "1rem" }}>Downloading...</span>
            ) : (
              "Download"
            )}
          </LoadingButton>
        </div>
      </Card>
    </>
  );
}
